import React from 'react';
import { Row, Col, Button } from 'antd';
import { form_item_size } from '@common/theme';

class BtnAddNew extends React.Component {
  render() {
    return (
      <div style={{
        padding: '10px',
        background: '#fff',
        // borderBottom: '1px solid #e8e8e8'
      }}>
        <Row>
          <Col style={{textAlign: 'right'}}>
            <Button
              size={ form_item_size }
              type='primary'
              onClick={ this.props.onClick }>
              { this.props.text }
            </Button>
          </Col>
        </Row>
      </div>
    )
  }
}

export default BtnAddNew;



// WEBPACK FOOTER //
// ./src/components/BtnAddNew/BtnAddNew.jsx